import React from "react";
import { Link } from "react-router-dom";
import "./Courses_Details.css";
import all_Course_details from "./Courses-Data.json";
export default function Courses_Details() {
  return (
    <>
      <section className="coursesCardSection">
        <div className="courses_Title">
          <h4>COURSES</h4>
          <h1>Browse Our Courses</h1>
        </div>
        <div id="outer_div">
          {all_Course_details.map((val) => (
            <div
              id="card_body"
              key={val.id}
              className="row row-cols-2 row-cols-md-4  h-25">
              <div className="card" id="coursesCardDiv">
                <img
                  src={val.cover}
                  className="card-img-top"
                  id="cardImage"
                  alt={val.courseName}
                />
                <div className="card-body" id="c_details">
                  <h6
                    id="coursesTitle"
                    className="card-title text-center fw-bold">
                    {val.courseName}
                  </h6>
                  <Link to={val.link} id="knowMore">
                    {val.course}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
